module.exports = __webpack_public_path__ + "static/media/8902_Kitchen.d8c8c55f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8902_Kitchen.jpg
// module id = 585
// module chunks = 0